import createStore from '@/store/index.js'
import { ShipMethod, AutoMemo, ManualSelectMemo } from '@/const/const.js'
import { UploadDataType } from '@/const/const'
import { importFile, convertCsvData } from '@/ts/loadData/importFile.js'

// 出品用レポートのアップロード処理
export const uploadAmazonIsbnData = (file) => {
  console.log('isbnUpload')
  importFile(file).then((csvBuf) => {
    console.log('isbn')
    const csvData = convertCsvData(csvBuf)
    checkIsbnData(csvData)
  })
}

// 各ストアの出品データ処理
export const uploadShippingData = (file) => {
  importFile(file).then((csvBuf) => {
    const csvData = convertCsvData(csvBuf)
    checkShippingData(csvData, csvBuf)
  })
}

const amazonKeys = [
  { key: 'order-id', index: -1 },
  { key: 'order-item-id', index: -1 },
  { key: 'buyer-email', index: -1 },
  { key: 'sku', index: -1 },
  { key: 'product-name', index: -1 },
  { key: 'quantity-purchased', index: -1 },
  { key: 'item-price', index: -1 },
  { key: 'shipping-price', index: -1 },
  { key: 'recipient-name', index: -1 },
  { key: 'ship-address-1', index: -1 },
  { key: 'ship-address-2', index: -1 },
  { key: 'ship-address-3', index: -1 },
  { key: 'ship-city', index: -1 },
  { key: 'ship-state', index: -1 },
  { key: 'ship-postal-code', index: -1 },
  { key: 'ship-phone-number', index: -1 },
  { key: 'item-promotion-discount', index: -1 },
  { key: 'ship-promotion-discount', index: -1 },
  { key: 'delivery-Instructions', index: -1 }
]

const japaneseBookKeys = [
  { key: "注文ID", index: -1 }, // 0 order-id
  { key: "保管場所", index: -1 }, // 1 order-item-id
  { key: "自店用在庫管理コード", index: -1 }, // 2 sku
  { key: "書名", index: -1 }, // 3 product-name
  { key: "税込価格", index: -1 }, // 10 item-price
  { key: "備考", index: -1 }, // 12 memo2
  { key: "注文者メールアドレス", index: -1 }, // 20 buyer-email
  { key: "注文者国名", index: -1 }, // 24 memo1
  { key: "お届け先姓", index: -1 }, // 29 recipient-name-1
  { key: "お届け先名", index: -1 }, // 30 recipient-name-2
  { key: "お届け先会社名", index: -1 }, // 33 ship-address-3
  { key: "お届け先TEL", index: -1 }, // 34 ship-phone-number
  { key: "お届け先郵便番号", index: -1 }, // 38 ship-postal-code
  { key: "お届け先都道府県", index: -1 }, // 39 ship-state
  { key: "お届け先市区町村", index: -1 }, // 40 ship-address-1
  { key: "お届け先番地/ビル名", index: -1 }, // 41 ship-address-2
  { key: "支払い方法", index: -1 } // 44 定型メモ 公費 || 代金引換(代引)
]

const yahooAuctionKeys = [
  { key: 'OrderId', index: -1 }, // 0 order-id
  { key: 'YahooAuctionId', index: -1 }, // 1 order-item-id
  { key: 'YahooAuctionMerchantId', index: -1 }, // 6 sku isbn
  { key: 'Title', index: -1 }, // 7 product-name
  { key: 'NonTaxUnitPrice', index: -1 }, // 9 item-price(税抜きのため税込み変換)
  { key: 'ShipCharge', index: -1 }, // 10 shipping-price
  { key: 'ShipName', index: -1 }, // 11 recipient-name
  { key: 'ShipAddress1', index: -1 }, // 12 ship-address-1
  { key: 'ShipAddress2', index: -1 }, // 13 ship-address-2
  { key: 'ShipSection1Value', index: -1 }, // 14 ship-address-3-1
  { key: 'ShipSection2Value', index: -1 }, // 15 ship-address-3-2
  { key: 'ShipCity', index: -1 }, // 16 ship-city
  { key: 'ShipPrefecture', index: -1 }, // 17 ship-state
  { key: 'ShipZipCode', index: -1 }, // 18 ship-postal-code
  { key: 'ShipPhoneNumber', index: -1 }, // 20 ship-phone-number
  { key: 'ShipNotes', index: -1 }, // 21 memo
  { key: 'ShipMethod', index: -1 }, // 22 postage1:ネコポス postage2: ゆうパック
]

const isbnKeys = [
  { key: '出品者SKU', index: -1 },
  { key: 'asin', index: -1 },
  { key: '価格', index: -1 },
  { key: '数量', index: -1 }
]

// ヘッダーに主要データが含まれているか確認
const checkHeader = (headers, keys) => {
  const rtn = { value: true }
  keys.forEach(k => {
    const index = headers.indexOf(k.key)
    if (index === -1) {
      rtn.value = false
    } else {
      k.index = index
    }
  })
  return { res: rtn.value, keys: keys }
}

const checkShippingData = (records, csvBuf) => {
  const shippingData = { value: [], type: UploadDataType.Undefine }
  // データが存在するならば
  if (records.length > 1) {
    const japaneseBook = checkHeader(records[0], japaneseBookKeys)
    // 日本の古本屋のヘッダーならば
    if (japaneseBook.res) {
      console.log('日本の古本屋')
      const japaneseBookRecords = importJapaneseBookData(records, japaneseBook.keys)
      shippingData.value = sortShippingData(japaneseBookRecords, true)
      shippingData.type = UploadDataType.JapaneseBook
      console.log(shippingData.value)
    }
    const amazon = checkHeader(records[0], amazonKeys)
    if (amazon.res) {
      console.log('amazon')
      const amazonRecords = importAmazonData(csvBuf, amazon.keys)
      shippingData.value = sortShippingData(amazonRecords, true)
      shippingData.type = UploadDataType.Amazon
    }
    const yahooAuction = checkHeader(records[0], yahooAuctionKeys)
    if (yahooAuction.res) {
      console.log('yahoo')
      const yahooAuctionRecords = importYahooAuctionData(records, yahooAuction.keys)
      shippingData.value = sortShippingData(yahooAuctionRecords, false)
      shippingData.type = UploadDataType.YahooAuction
    }
  }
  const store = createStore
  store.commit('setShippingData', { data: shippingData.value, type: shippingData.type })
}

// isbnデータArray
const checkIsbnData = (csvData) => {
  const isbn = checkHeader(csvData[0], isbnKeys)
  if (isbn.res) {
    console.log('isbn')
    const isbnRecords = importIsbnData(csvData, isbn.keys)
    console.log(isbnRecords)
    const store = createStore
    store.commit('setIsbnData', { data: isbnRecords })
  }
}

/*
const old_checkShippingData = (buf) => {
  const shippingData = { value: [], type: UploadDataType.Undefine }
  const records = buf.split('\r\n')
  // データが存在するならば
  if (records.length > 1) {
    let header = records[0]
    // 分割文字が","ならば
    if (header.indexOf('","') !== -1) {
      header = header.slice(1).slice(0, -1).split('","')
      console.log(header)
      const japaneseBook = checkHeader(header, japaneseBookKeys)
      console.log(japaneseBook)
      // 日本の古本屋のヘッダーならば
      if (japaneseBook.res) {
        console.log('日本の古本屋')
        const japaneseBookRecords = importJapaneseBookData(buf, japaneseBook.keys)
        shippingData.value = sortShippingData(japaneseBookRecords)
        shippingData.type = UploadDataType.JapaneseBook
        console.log(shippingData.value)
      }
    } else {
      if (header.indexOf('\t') !== -1) {
        header = header.split('\t')
        const amazon = checkHeader(header, amazonKeys)
        if (amazon.res) {
          console.log('amazon')
          const amazonRecords = importAmazonData(buf, amazon.keys)
          shippingData.value = sortShippingData(amazonRecords)
          shippingData.type = UploadDataType.Amazon
        }
      } else if (header.indexOf(',') !== 1) {
        header = header.split(',')
        const yahooAuction = checkHeader(header, yahooAuctionKeys)
        if (yahooAuction.res) {
          console.log('yahoo')
          const yahooAuctionRecords = importYahooAuctionData(buf, yahooAuction.keys)
          shippingData.value = sortShippingData(yahooAuctionRecords)
          shippingData.type = UploadDataType.YahooAuction
        }
      }
    }
  }

  const store = createStore
  store.commit('setShippingData', { data: shippingData.value, type: shippingData.type })
}
*/

// amazonのデータインポート
const importAmazonData = (csvBuf, keys) => {
  const orderIdIndex = keys.find(x => x.key === 'order-id').index
  const orderItemIdIndex = keys.find(x => x.key === 'order-item-id').index
  const buyerEmailIndex = keys.find(x => x.key === 'buyer-email').index
  const skuIndex = keys.find(x => x.key === 'sku').index
  const productNameIndex = keys.find(x => x.key === 'product-name').index
  const quantityPurchasedIndex = keys.find(x => x.key === 'quantity-purchased').index
  const itemPriceIndex = keys.find(x => x.key === 'item-price').index
  const shippingPriceIndex = keys.find(x => x.key === 'shipping-price').index
  const recipientNameIndex = keys.find(x => x.key === 'recipient-name').index
  const shipAddress1Index = keys.find(x => x.key === 'ship-address-1').index
  const shipAddress2Index = keys.find(x => x.key === 'ship-address-2').index
  const shipAddress3Index = keys.find(x => x.key === 'ship-address-3').index
  const shipCityIndex = keys.find(x => x.key === 'ship-city').index
  const shipStateIndex = keys.find(x => x.key === 'ship-state').index
  const shipPostalCodeIndex = keys.find(x => x.key === 'ship-postal-code').index
  const shipPhoneNumberIndex = keys.find(x => x.key === 'ship-phone-number').index
  const itemPromotionDiscountIndex = keys.find(x => x.key === 'item-promotion-discount').index
  const shipPromotionDiscountIndex = keys.find(x => x.key === 'ship-promotion-discount').index
  const memoIndex = keys.find(x => x.key === 'delivery-Instructions').index

  const records = csvBuf.split('\r\n')
  let tmpRecords = records.map((x, index) => {
    const record = x.split('\t')
    return {
      checked: true,
      index: index,
      orderId: record[orderIdIndex],
      orderItemId: record[orderItemIdIndex],
      buyerEmail: record[buyerEmailIndex],
      sku: record[skuIndex],
      productName: record[productNameIndex],
      quantityPurchased: Number(record[quantityPurchasedIndex]),
      itemPrice: Number(record[itemPriceIndex]),
      shippingPrice: Number(record[shippingPriceIndex]),
      recipientName: record[recipientNameIndex],
      shipAddress1: record[shipAddress1Index],
      shipAddress2: record[shipAddress2Index],
      shipAddress3: record[shipAddress3Index],
      shipCity: record[shipCityIndex],
      shipState: record[shipStateIndex],
      shipPostalCode: record[shipPostalCodeIndex],
      shipPhoneNumber: record[shipPhoneNumberIndex],
      itemPromotionDiscount: Number(record[itemPromotionDiscountIndex]),
      shipPromotionDiscount: Number(record[shipPromotionDiscountIndex]),
      shipMethod: 0,
      isbn: '',
      memo: record[memoIndex]
    }
  })

  // ヘッダー削除
  tmpRecords.shift()
  // 最終行削除
  tmpRecords.pop()
  // buyerEmail空欄を除外
  tmpRecords = tmpRecords.filter(x => x.buyerEmail !== '')

  return tmpRecords
}

// 日本の古本屋のデータインポート
const importJapaneseBookData = (records, keys) => {
  const orderIdIndex = keys.find(x => x.key === '注文ID').index
  // const orderItemIdIndex = keys.find(x => x.key === '保管場所').index
  const buyerEmailIndex = keys.find(x => x.key === '注文者メールアドレス').index
  const skuIndex = keys.find(x => x.key === '自店用在庫管理コード').index
  const productNameIndex = keys.find(x => x.key === '書名').index
  // const quantityPurchasedIndex = keys.find(x => x.key === 'quantity-purchased').index
  const itemPriceIndex = keys.find(x => x.key === '税込価格').index
  // const shippingPriceIndex = keys.find(x => x.key === 'shipping-price').index
  const recipient1NameIndex = keys.find(x => x.key === 'お届け先姓').index
  const recipient2NameIndex = keys.find(x => x.key === 'お届け先名').index
  const shipAddress1Index = keys.find(x => x.key === 'お届け先市区町村').index
  const shipAddress2Index = keys.find(x => x.key === 'お届け先番地/ビル名').index
  const shipAddress3Index = keys.find(x => x.key === 'お届け先会社名').index
  // const shipCityIndex = keys.find(x => x.key === 'ship-city').index
  const shipStateIndex = keys.find(x => x.key === 'お届け先都道府県').index
  const shipPostalCodeIndex = keys.find(x => x.key === 'お届け先郵便番号').index
  const shipPhoneNumberIndex = keys.find(x => x.key === 'お届け先TEL').index
  // const itemPromotionDiscountIndex = keys.find(x => x.key === 'item-promotion-discount').index
  // const shipPromotionDiscountIndex = keys.find(x => x.key === 'ship-promotion-discount').index
  const isbnIndex = keys.find(x => x.key === '保管場所').index
  const payMethodIndex = keys.find(x => x.key === '支払い方法').index
  const memo1Index = keys.find(x => x.key === '注文者国名').index
  const memo2Index = keys.find(x => x.key === '備考').index

  // const records = buf.split('\r\n')
  let tmpRecords = records.map((x, index) => {
    // const record = x.slice(1).slice(0, -1).split('","')
    const record = x
    const memo = convertJapaneseBookPayMethod(record[payMethodIndex]) + record[memo1Index] + ' ' + record[memo2Index]
    return {
      checked: true,
      index: index,
      orderId: record[orderIdIndex],
      orderItemId: '',
      buyerEmail: record[buyerEmailIndex],
      sku: record[skuIndex],
      productName: record[productNameIndex],
      quantityPurchased: 1, // record[quantityPurchasedIndex],
      itemPrice: Number(record[itemPriceIndex]),
      shippingPrice: 350, // record[shippingPriceIndex],
      recipientName: record[recipient1NameIndex] + ' ' + record[recipient2NameIndex],
      shipAddress1: record[shipAddress1Index],
      shipAddress2: record[shipAddress2Index],
      shipAddress3: record[shipAddress3Index],
      shipCity: '', // record[shipCityIndex],
      shipState: record[shipStateIndex],
      shipPostalCode: record[shipPostalCodeIndex],
      shipPhoneNumber: record[shipPhoneNumberIndex],
      itemPromotionDiscount: 0, // record[itemPromotionDiscountIndex],
      shipPromotionDiscount: 0, // record[shipPromotionDiscountIndex],
      shipMethod: ShipMethod.PostMail.Index,
      isbn: record[isbnIndex],
      memo: memo.trim()
    }
  })

  // ヘッダー削除
  tmpRecords.shift()
  // 最終行削除
  tmpRecords.pop()

  return tmpRecords
}

// 日本の古本屋 支払い方法を変換
const convertJapaneseBookPayMethod = (strPayMethod) => {
  const rtn = { value: '' }
  switch (strPayMethod) {
    case '公費':
      rtn.value = '公費 '
      break
    case '代金引換':
      rtn.value = '代引 '
      break
  }
  return rtn.value
}

// ヤフオクのデータインポート
const importYahooAuctionData = (records, keys) => {
  console.log(keys)
  const orderIdIndex = keys.find(x => x.key === 'OrderId').index
  const orderItemIdIndex = keys.find(x => x.key === 'YahooAuctionId').index
  // const buyerEmailIndex = keys.find(x => x.key === 'buyer-email').index
  const yahooAuctionMerchantIdIndex = keys.find(x => x.key === 'YahooAuctionMerchantId').index
  // const skuIndex = keys.find(x => x.key === 'sku').index
  const productNameIndex = keys.find(x => x.key === 'Title').index
  // const quantityPurchasedIndex = keys.find(x => x.key === 'quantity-purchased').index
  const itemPriceIndex = keys.find(x => x.key === 'NonTaxUnitPrice').index
  const shippingPriceIndex = keys.find(x => x.key === 'ShipCharge').index
  const recipientNameIndex = keys.find(x => x.key === 'ShipName').index
  const shipAddress1Index = keys.find(x => x.key === 'ShipAddress1').index
  const shipAddress2Index = keys.find(x => x.key === 'ShipAddress2').index
  // const shipAddress3Index = keys.find(x => x.key === 'ship-address-3').index
  const shipSection1ValueIndex = keys.find(x => x.key === 'ShipSection1Value').index
  const shipSection2ValueIndex = keys.find(x => x.key === 'ShipSection2Value').index
  const shipCityIndex = keys.find(x => x.key === 'ShipCity').index
  const shipStateIndex = keys.find(x => x.key === 'ShipPrefecture').index
  const shipPostalCodeIndex = keys.find(x => x.key === 'ShipZipCode').index
  const shipPhoneNumberIndex = keys.find(x => x.key === 'ShipPhoneNumber').index
  // const itemPromotionDiscountIndex = keys.find(x => x.key === 'item-promotion-discount').index
  // const shipPromotionDiscountIndex = keys.find(x => x.key === 'ship-promotion-discount').index
  const shipMethodIndex = keys.find(x => x.key === 'ShipMethod').index
  const memoIndex = keys.find(x => x.key === 'ShipNotes').index

  // const records = buf.split('\r\n')

  // 最終行削除
  // 最終行(仮行)の処理で処理が止まるため
  records.pop()

  let tmpRecords = records.map((x, index) => {
    // const record = x.split(',')
    const record = x
    const productName = String(record[productNameIndex])
    return {
      checked: true,
      index: index,
      orderId: record[orderIdIndex],
      orderItemId: record[orderItemIdIndex],
      buyerEmail: '',
      sku: getYahooAuctionSku(record[yahooAuctionMerchantIdIndex]),
      productName: productName.replace('L1=', ''),
      quantityPurchased: 1,
      itemPrice: Math.floor(Number(record[itemPriceIndex]) * 1.1),
      shippingPrice: Number(record[shippingPriceIndex]),
      recipientName: record[recipientNameIndex],
      shipAddress1: record[shipAddress1Index],
      shipAddress2: record[shipAddress2Index],
      shipAddress3: record[shipSection1ValueIndex] + ' ' + record[shipSection2ValueIndex],
      shipCity: record[shipCityIndex],
      shipState: record[shipStateIndex],
      shipPostalCode: convertYahooAuctionPostCode(record[shipPostalCodeIndex]),
      shipPhoneNumber: record[shipPhoneNumberIndex],
      itemPromotionDiscount: 0,
      shipPromotionDiscount: 0,
      shipMethod: convertYahooAuctionShipMethod(record[shipMethodIndex]),
      isbn: getYahooAuctionIsbn(record[yahooAuctionMerchantIdIndex]),
      memo: record[memoIndex]
    }
  })

  // ヘッダー削除
  tmpRecords.shift()

  return tmpRecords
}

const importIsbnData = (records, keys) => {
  const skuIndex = keys.find(x => x.key === '出品者SKU').index
  const asinIndex = keys.find(x => x.key === 'asin').index
  const itemPriceIndex = keys.find(x => x.key === '価格').index
  const quantityPurchasedIndex = keys.find(x => x.key === '数量').index

  let tmpRecords = records.map((x, index) => {
    const record = x
    return {
      sku: record[skuIndex],
      quantityPurchased: record[quantityPurchasedIndex],
      itemPrice: Number(record[itemPriceIndex]),
      isbn: record[asinIndex],
    }
  })

  tmpRecords.pop()
  tmpRecords.shift()
  return tmpRecords
}

// ヤフオク　住所文字数調整
const getAddress = (state, city, address1, address2, address3) => {
  const rtn = { address1: address1, address2: address2, address3: address3 }
  //　一か所でも超えるならば
  if (isOverByte(state + city + address1, 50) || isOverByte(address2, 50) || isOverByte(address3, 50)) {
    const bytesLen = enc.GetByteCount(state + city);

    const tmp = add1 + add2 + add3;

    const c1 = getByteSubstr(tmp, 50 - bytesLen)
    const c2 = getByteSubstr(c1.res, 50)
    
    rtn.address1 = c1.text
    rtn.address2 = c2.text
    rtn.address3 = c2.res
  }
  return rtn
}

const isOverByte = (str, limit) => {
  return (encodeURIComponent(str).replace(/%../g,"x").length > limit)
}

const getByteSubstr = (text, len) => {
  rtn = { text: '', res: '' }
  textArray = text.split('')
  let count = 0
  let i = 0
  let str = ''
  while (i < textArray.length) {
    const c = text[i]
    count += encodeURIComponent(c).replace(/%../g,"x").length
    if (count > len) {
      rtn.text = str
      rtn.res = text.substr(i)
    }
    str += c
    i++
  }
  return rtn
}

// ヤフオク sku取得
const getYahooAuctionSku = (key) => {
  const rtn = { value: String(key) }
  const startIndex = key.indexOf('(')

  if (startIndex !== -1)
  {
    rtn.value = key.substr(0, startIndex)
  }

  return rtn.value
}

// ヤフオク isbn取得
const getYahooAuctionIsbn = (key) => {
  const rtn = { value: String(key) }
  const startIndex = key.indexOf('(')
  const endIndex = key.indexOf(')')
  // ()が存在するならば
  if (startIndex !== -1 && endIndex !== -1)
  {
    rtn.value = key.substr(startIndex + 1, endIndex - startIndex - 1 )
    // アルファベットがあるならば削除
    let buf = ''
    for (let i = 0; i < rtn.value.length; i++) {
      if (!isAlphabet(rtn.value[i])) {
        buf += rtn.value[i]
      }
    }
    
    rtn.value = buf

    // ハイフンがあるならば分割・後ろを取得
    if (rtn.value.indexOf('-') !== -1) {
      rtn.value = rtn.value.split('-')[1]
    }
  }

  return rtn.value
}

const isAlphabet = (c) => {
  return (c >= 'A' && c <= 'z') ? true : false
}

// ヤフオク 配送方法を変換
const convertYahooAuctionShipMethod = (strShipMethod) => {
  const rtn = { value: ShipMethod.Nekopos.Index}
  switch (strShipMethod) {
    case 'postage1':
      rtn.value = ShipMethod.Nekopos.Index
      break
    case 'postage2':
      rtn.value = ShipMethod.PostPack.Index
      break
  }
  return rtn.value
}

// ヤフオク 郵便番号を変換
const convertYahooAuctionPostCode = (shipPostcode) => {
  const rtn = { value: String(shipPostcode) }
  if (rtn.value.length === 7) {
    rtn.value = rtn.value.slice(0, 3) + '-' + rtn.value.slice(3)
  }
  return rtn.value
}

// 同梱処理と並べ替え
const sortShippingData = (_items, setShipMethod) => {
  // Emailと住所が一致しているならば同梱処理
  console.log(_items)
  const items = []
  _items.forEach(x => {
    const item = {
      checked: true,
      orderItemId: x.orderItemId,
      sku: x.sku,
      productName: x.productName,
      quantityPurchased: x.quantityPurchased,
      itemPrice: x.itemPrice,
      shippingPrice: x.shippingPrice,
      isbn: x.isbn
    }
    const matched = items.some(y => (y.buyerEmail === x.buyerEmail) && (y.shipPostalCode === x.shipPostalCode) && (y.shipState === x.shipState) && (y.shipCity === x.shipCity) && (y.shipAddress1 === x.shipAddress1) && (y.shipAddress2 === x.shipAddress2) && (y.shipAddress3 === x.shipAddress3) && (y.recipientName === x.recipientName))
    if (matched) {
      const target = items.find(y => (y.buyerEmail === x.buyerEmail) && (y.shipPostalCode === x.shipPostalCode) && (y.shipState === x.shipState) && (y.shipCity === x.shipCity) && (y.shipAddress1 === x.shipAddress1) && (y.shipAddress2 === x.shipAddress2) && (y.shipAddress3 === x.shipAddress3) && (y.recipientName === x.recipientName))
      target.items.push(item)
    } else {
      const newItem = {
        index: 0,
        checked: true,
        checkedStep3: true,
        checkedStep4: true,
        orderId: x.orderId,
        buyerEmail: x.buyerEmail,
        recipientName: x.recipientName,
        shipCity: x.shipCity,
        shipAddress1: x.shipAddress1,
        shipAddress2: x.shipAddress2,
        shipAddress3: x.shipAddress3,
        shipState: x.shipState,
        shipPostalCode: x.shipPostalCode,
        shipPhoneNumber: x.shipPhoneNumber,
        shipMethod: x.shipMethod,
        itemPromotionDiscount: x.itemPromotionDiscount,
        shipPromotionDiscount: x.shipPromotionDiscount,
        memo: x.memo,
        items: [],
        manualSelectMemo: ManualSelectMemo.None.Index,
        address: function () {
          return this.shipState + ' ' + this.shipCity + ' ' + this.shipAddress1 + ' ' + this.shipAddress2 + ' ' + this.shipAddress3
        },
        totalPrice: function () {
          const rtn = { value: 0 }
          const items = this.items
          items.forEach(x => {
            const price = x.itemPrice + x.shippingPrice
            rtn.value += price
          })
          return rtn.value
        },
        autoMemo: function () {
          const rtn = { value: [] }
          const items = this.items
          
          // 1個より商品が多いならば
          items.forEach(x => {
            if (x.quantityPurchased > 1) {
              rtn.value.push(AutoMemo.More.Label)
            }
          })

          // 住所に「郵便局」があるならば
          if (this.address().indexOf('郵便局') > 0) {
            rtn.value.push(AutoMemo.PostOffice.Label)
          }
          // 収入印紙
          if (this.totalPrice() >= 50000) {
            rtn.value.push(AutoMemo.Stamp.Label)
          }

          // プチプチ梱包
          if (this.shipMethod === ShipMethod.PostPack.Index) {
            rtn.value.push(AutoMemo.Packing.Label)
          }
          return rtn.value
        },
        shipMethodLabel: function () {
          const rtn = { value: '' }
          switch(this.shipMethod) {
            case ShipMethod.PostMail.Index:
              rtn.value = ShipMethod.PostMail.Label
              break
            case ShipMethod.Nekopos.Index:
              rtn.value = ShipMethod.Nekopos.Label
              break
            case ShipMethod.PostPack.Index:
              rtn.value = ShipMethod.PostPack.Label
              break
          }
          return rtn.value
        }
      }
      newItem.items.push(item)
      items.push(newItem)
    }
  })

  // 同梱並び替え
  items.sort((a, b) => {
    if (a.items.length - b.items.length > 0) {
      return 2
    } else {
      const a1 = a.items[0].sku.toLowerCase()
      const b1 = b.items[0].sku.toLowerCase()
      if (a1 < b1) return -1
      if (a1 > b1) return 1
    }
  })

  // sku並び替え
  items.sort((a, b) => a.items.length - b.items.length)

  // 配送方法を固定
  if (setShipMethod) {
    items.forEach(x => {

      if (x.totalPrice() > 7999 ) {
        x.shipMethod = ShipMethod.PostPack.Index
      } else if (x.totalPrice() >= 2000) {
        x.shipMethod = ShipMethod.Nekopos.Index
      } else {
        x.shipMethod = ShipMethod.PostMail.Index
      }
    })
  }

  return items
}

const shippingImport = (res) => {

  const tmp = res.split('\r\n')
  console.log(tmp)
  let tmpRecords = tmp.map((x, index) => {
    const record = x.split('\t')
    return {
      checked: true,
      index: index,
      orderId: record[0],
      orderItemId: record[1],
      purchaseDate: record[2],
      paymentsDate: record[3],
      buyerEmail: record[4],
      buyerName: record[5],
      buyerPhoneNumber: record[6],
      sku: record[7],
      productName: record[8],
      quantityPurchased: record[9],
      currency: record[10],
      itemPrice: record[11],
      itemTax: record[12],
      shippingPrice: record[13],
      shippingTax: record[14],
      shipServiceLevel: record[15],
      recipientName: record[16],
      shipAddress1: record[17],
      shipAddress2: record[18],
      shipAddress3: record[19],
      shipCity: record[20],
      shipState: record[21],
      shipPostalCode: record[22],
      shipCountry: record[23],
      shipPhoneNumber: record[24],
      itemPromotionDiscount: record[25],
      itemPromotionId: record[26],
      shipPromotionDiscount: record[27],
      shipPromotionId: record[28],
      deliveryStartDate: record[29],
      deliveryEndDate: record[30],
      deliveryTimeZone: record[31],
      deliveryInstructions: record[32]
    }
  })

  // ヘッダー削除
  tmpRecords.shift()
  // 最終行削除
  tmpRecords.pop()
  // buyerEmail空欄を除外
  tmpRecords = tmpRecords.filter(x => x.buyerEmail !== '')
  // records.value = tmpRecords

  // Emailと住所が一致しているならば同梱処理
  const items = []
  tmpRecords.forEach(x => {
    const item = {
      checked: true,
      orderItemId: x.orderItemId,
      sku: x.sku,
      productName: x.productName,
      quantityPurchased: x.quantityPurchased,
      currency: x.currency,
      itemPrice: x.itemPrice,
      itemTax: x.itemTax,
      shippingPrice: x.shippingPrice,
      shippingTax: x.shippingTax
    }
    const matched = items.some(y => (y.buyerEmail === x.buyerEmail) && (y.shipPostalCode === x.shipPostalCode) && (y.shipState === x.shipState) && (y.shipCity === x.shipCity) && (y.shipAddress1 === x.shipAddress1) && (y.shipAddress2 === x.shipAddress2) && (y.shipAddress3 === x.shipAddress3) && (y.recipientName === x.recipientName))
    if (matched) {
      const target = items.find(y => (y.buyerEmail === x.buyerEmail) && (y.shipPostalCode === x.shipPostalCode) && (y.shipState === x.shipState) && (y.shipCity === x.shipCity) && (y.shipAddress1 === x.shipAddress1) && (y.shipAddress2 === x.shipAddress2) && (y.shipAddress3 === x.shipAddress3) && (y.recipientName === x.recipientName))
      target.items.push(item)
    } else {
      const newItem = {
        checked: true,
        orderId: x.orderId,
        purchaseDate: x.purchaseDate,
        paymentsDate: x.paymentsDate,
        buyerEmail: x.buyerEmail,
        buyerName: x.buyerName,
        buyerPhoneNumber: x.buyerPhoneNumber,
        shipServiceLevel: x.shipServiceLevel,
        recipientName: x.recipientName,
        shipAddress1: x.shipAddress1,
        shipAddress2: x.shipAddress2,
        shipAddress3: x.shipAddress3,
        shipCity: x.shipCity,
        shipState: x.shipState,
        shipPostalCode: x.shipPostalCode,
        shipCountry: x.shipCountry,
        shipPhoneNumber: x.shipPhoneNumber,
        itemPromotionDiscount: x.itemPromotionDiscount,
        itemPromotionId: x.itemPromotionId,
        shipPromotionDiscount: x.shipPromotionDiscount,
        shipPromotionId: x.shipPromotionId,
        deliveryStartDate: x.deliveryStartDate,
        deliveryEndDate: x.deliveryEndDate,
        deliveryTimeZone: x.deliveryTimeZone,
        deliveryInstructions: x.deliveryInstructions,
        items: []
      }
      newItem.items.push(item)
      items.push(newItem)
    }
  })

  // 同梱並び替え
  items.sort((a, b) => {
    if (a.items.length - b.items.length > 0) {
      return 2
    } else {
      const a1 = a.items[0].sku.toLowerCase()
      const b1 = b.items[0].sku.toLowerCase()
      if (a1 < b1) return -1
      if (a1 > b1) return 1
    }
  })

  // sku並び替え
  items.sort((a, b) => a.items.length - b.items.length)

  return items
}